import React from 'react';
import { connect } from 'react-redux';
import fbCarousel1 from 'assets/images/backoffice/online-store/fb-carousel-1-eng.png';
import fbCarousel2 from 'assets/images/backoffice/online-store/fb-carousel-2-eng.png';
import fbCarousel3 from 'assets/images/backoffice/online-store/fb-carousel-3-eng.png';
import fbCarousel4 from 'assets/images/backoffice/online-store/fb-carousel-4-eng.png';
import fbLogoSmall from 'assets/images/backoffice/online-store/fb-logo-small.png';
import igLogoSmall from 'assets/images/backoffice/online-store/ig-logo-small.png';
import TooltipHint from 'components/TooltipHint/TooltipHint';
import LandingPage from 'pages/OnlineStore/LandingPage/LandingPage';
import OutletModal from 'pages/OnlineStore/OutletModal/OutletModal';
import DisconnectShopModal from 'pages/OnlineStore/DisconnectShopModal/DisconnectShopModal';
import PageHeader from 'pages/OnlineStore/LandingPage/PageHeader';
import ProductSyncingModal from 'pages/OnlineStore/ProductSyncingModal/ProductSyncingModal';
import GoStoreNotActivatedModal from 'pages/OnlineStore/GoStoreNotActivatedModal/GoStoreNotActivatedModal';
import { FacebookProvider, InitFacebook } from 'react-facebook';
import {
  startSyncingProductValidationFlow,
  startFacebokSignInFlow,
  pageRequest,
  startSelectOutletFlow,
  showDisconnectShopModal,
  showFacebookDomainVerificationModal,
} from 'actions/onlineStore';
import * as fbClevertap from 'clevertap/onlineStore/facebook';
import isExperienceComplete from 'selectors/isExperienceComplete';
import { completeExperience } from 'reducers/ftue/actions';
import { FTUE_ONLINE_STORE_FACEBOOK_RED_DOT } from 'reducers/ftue/ftueKeys';
import {
  CONNECT_FB_SOURCE,
  ONLINE_STORE_CHANNEL,
  SHOULD_MOCK,
} from 'utils/onlineStoreUtils';
import LearnMore from 'pages/OnlineStore/ConnectedOutletList/LearnMore/LearnMore';
import OutletColumn from 'pages/OnlineStore/ConnectedOutletList/OutletColumn/OutletColumn';
import ProductCountColumn from 'pages/OnlineStore/ConnectedOutletList/ProductCountColumn/ProductCountColumn';
import NotConnected from 'pages/OnlineStore/ConnectedOutletList/NotConnected/NotConnected';
import ShopActionColumn from 'pages/OnlineStore/ConnectedOutletList/ShopActionColumn/ShopActionColumn';
import FacebookDomainVerificationModal from './FacebookDomainVerificationModal/FacebookDomainVerificationModal';
import styles from './FacebookShop.css';

const landingPageProps = {
  icons: [fbLogoSmall, igLogoSmall],
  pageTitle: 'FACEBOOK AND INSTAGRAM SHOP',
  headingText: 'Showcase and Sell Your Product on Facebook and Instagram',
  headingDescription: (
    <span>
      Create shop easily by connecting your <b>Facebook account</b> that is
      linked to <b>Instagram business account</b>. Your Facebook and Instagram
      Shop will be active within minutes! Get discovered by users all over
      Indonesia.
    </span>
  ),
  carouselImages: [fbCarousel1, fbCarousel2, fbCarousel3, fbCarousel4],
  ctaText: 'Connect to Facebook',
  howToUrl: 'https://mokaposhelp.zendesk.com/hc/id',
  howToDescription: 'Benefit of selling your product on Facebook & Instagram:',
  howToItems: [
    'We help to create Facebook & Instagram Shop for your outlet.',
    'We help to upload & update your Moka items to Facebook & Instagram anytime.',
    'Manage your inventory in one place: Moka!',
  ],
};

const fbTooltip = (
  <span className={styles['tooltip-text']}>
    <b>Facebook Username Account</b> that is connected to your Outlet and
    Facebook Page.
  </span>
);

const igTooltip = (
  <span className={styles['tooltip-text']}>
    <b>Instagram Username Account</b> that is connected to your Outlet and
    Facebook Page.
  </span>
);

const noop = () => {};

class FacebookShop extends React.Component {
  componentDidMount() {
    this.props.dispatch(pageRequest(ONLINE_STORE_CHANNEL.FACEBOOK));

    if (this.props.showRedDot) {
      this.props.dispatch(
        completeExperience(FTUE_ONLINE_STORE_FACEBOOK_RED_DOT)
      );
    }
  }

  render() {
    return (
      <FacebookProvider
        appId={process.env.FB_GOSTORE_APP_ID}
        version="v4.0"
        cookie={false}
        xfbml={false}
      >
        <InitFacebook onReady={noop}>
          <div className={styles.container}>
            {this._renderContent()}

            <OutletModal />
            <ProductSyncingModal />
            <DisconnectShopModal />
            <GoStoreNotActivatedModal />
            <FacebookDomainVerificationModal />
          </div>
        </InitFacebook>
      </FacebookProvider>
    );
  }

  _renderContent = () => {
    const { shops, pageRequestLoading, businessInfo } = this.props;

    if (pageRequestLoading && shops.length === 0) {
      return null;
    }

    if (shops.length === 0) {
      return (
        <LandingPage
          {...landingPageProps}
          onClick={this._handleLandingPageConnectFacebook}
        />
      );
    }

    return (
      <div className={styles['connected-outlet-list-container']}>
        <PageHeader
          icons={landingPageProps.icons}
          title={landingPageProps.pageTitle}
        />

        <div className={styles['sub-heading']}>
          <h2>Showcase and Sell Your Product on Facebook and Instagram</h2>
          <div>
            <p>
              Create shop easily by connecting your{' '}
              <b>Facebook business account</b> that is linked to{' '}
              <b>Instagram business account</b>. Your Facebook and Instagram
              Shop will be active within minutes! Get discovered by users all
              over Indonesia.
            </p>
            <button
              className="btn btn-primary"
              onClick={this._handleOutletListConnectFacebook}
            >
              Connect Another Outlet
            </button>
          </div>

          <hr />
        </div>

        {businessInfo.additional &&
          !businessInfo.additional.is_facebook_website_verified && (
            <div className={styles['domain-verification']}>
              <i className="glyphicon glyphicon-ok-circle" />
              <span>
                Complete the <b>domain verification</b> process{' '}
                <a onClick={this._handleDomainVerification}>here</a> in case
                it's failed. You can see your domain verification status
                on&nbsp;
                <a
                  target="_blank"
                  href="https://business.facebook.com/settings/owned-domains"
                >
                  Facebook domain page
                </a>
              </span>
            </div>
          )}

        <div className={styles['connected-outlet-list']}>
          <h3>Connected Outlet</h3>
          <table className={styles['outlet-table']}>
            <tr>
              <th>Facebook Page</th>
              <th>
                FB Username
                <TooltipHint color="#8F8F8F" tooltip={fbTooltip} />
              </th>
              <th>
                IG Username
                <TooltipHint color="#8F8F8F" tooltip={igTooltip} />
              </th>
              <th>Product Uploaded</th>
              <th>Action</th>
            </tr>

            {this._renderShops()}
          </table>
        </div>

        <LearnMore
          url="https://mokaposhelp.zendesk.com/hc/id"
          description="Need more Info on How to Start Facebook Shop?"
        />
      </div>
    );
  };

  _renderShops = () => {
    const { shops, outlets } = this.props;
    const notConnnectedEl = <NotConnected />;

    return shops
      .filter(shop => SHOULD_MOCK || outlets.some(o => o.id === shop.outlet_id))
      .map(shop => {
        const outlet = SHOULD_MOCK
          ? outlets[0]
          : outlets.filter(o => o.id === shop.outlet_id)[0];

        return (
          <tr key={shop.id}>
            <td>
              <OutletColumn outlet={outlet} shop={shop} />
            </td>
            <td
              title={
                shop.status === 'ACTIVE'
                  ? shop.additional.facebook_username
                  : null
              }
            >
              {shop.status === 'ACTIVE'
                ? shop.additional.facebook_username
                : notConnnectedEl}
            </td>
            <td
              title={
                shop.status === 'ACTIVE'
                  ? shop.additional.instagram_username
                  : null
              }
            >
              {shop.status === 'ACTIVE'
                ? shop.additional.instagram_username
                : notConnnectedEl}
            </td>
            <td>
              <ProductCountColumn
                shop={shop}
                onProductSync={this._handleStartSyncProduct}
              />
            </td>
            <td>
              <ShopActionColumn
                shop={shop}
                outlet={outlet}
                onDisconnect={this._handleDisconnect}
                onProductSync={this._handleStartSyncProduct}
                onContinueSetupOutlet={this._handleContinueSetupOutlet}
              />
            </td>
          </tr>
        );
      });
  };

  _handleDisconnect = (shop, outlet) => {
    fbClevertap.fbDisconnectClick();
    this.props.dispatch(showDisconnectShopModal(shop, outlet));
  };

  _handleContinueSetupOutlet = (outletId, outletName, shop) => {
    fbClevertap.fbContinueSetupClick();
    this.props.dispatch(
      startFacebokSignInFlow({
        outletId,
        outletName,
        shop,
        source: CONNECT_FB_SOURCE.CONTINUE_SETUP,
      })
    );
  };

  _handleStartSyncProduct = shop => {
    fbClevertap.fbUploadProductsClick();
    this.props.dispatch(startSyncingProductValidationFlow(shop.id, true));
  };

  _handleLandingPageConnectFacebook = () => {
    fbClevertap.fbConnectAccountClick();
    this.props.dispatch(
      startSelectOutletFlow(
        ONLINE_STORE_CHANNEL.FACEBOOK,
        CONNECT_FB_SOURCE.LANDING_PAGE
      )
    );
  };

  _handleOutletListConnectFacebook = () => {
    fbClevertap.fbConnectAnotherOutletClick();
    this.props.dispatch(
      startSelectOutletFlow(
        ONLINE_STORE_CHANNEL.FACEBOOK,
        CONNECT_FB_SOURCE.OUTLET_LIST_PAGE
      )
    );
  };

  _handleDomainVerification = () => {
    this.props.dispatch(showFacebookDomainVerificationModal());
  };
}

function mapStateToProps(state) {
  const { outlets } = state.moka.user;
  const {
    shop: { pageRequestLoading, shops, businessInfo },
  } = state.onlineStore;

  return {
    outlets,
    shops,
    businessInfo,
    pageRequestLoading,
    showRedDot: isExperienceComplete(state, FTUE_ONLINE_STORE_FACEBOOK_RED_DOT),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacebookShop);
